import React from "react"

interface GaugeChartProps {
  value: number
  total: number
  color: string
}

const GaugeChart: React.FC<GaugeChartProps> = ({ value, total, color }) => {
  const percentage = Math.round((value / total) * 100) // 반올림된 퍼센트 값
  const radius = 60 // 반지름
  const circumference = Math.PI * radius // 반원의 둘레
  const filled = Math.min((percentage / 100) * circumference, circumference) // 채워진 부분 계산

  return (
    <div style={{ width: "168px", height: "84px", position: "relative" }}>
      <svg
        width="168"
        height="84"
        viewBox="0 0 168 84"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: "visible" }}
      >
        {/* 배경 반원 */}
        <path
          d="M24 72 A60 60 0 0 1 144 72"
          fill="none"
          stroke="#e6e6e6"
          strokeWidth="12"
          strokeLinecap="round"
        />
        {/* 채워진 반원 */}
        <path
          d="M24 72 A60 60 0 0 1 144 72"
          fill="none"
          stroke={color}
          strokeWidth="12"
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={circumference - filled}
          strokeLinecap="round"
        />
      </svg>
      {/* 중앙 아래 텍스트 */}
      <div
        style={{
          position: "absolute",
          top: "44px", // 텍스트를 차트 아래로 배치 (적절히 조정)
          left: "50%",
          transform: "translate(-50%, 0%)",
          textAlign: "center",
          fontFamily: "SUIT",
          fontWeight: "400",
          color: "#262626",
        }}
      >
        <span style={{ fontSize: "24px" }}>{percentage}</span>
        <span style={{ fontSize: "16px", marginLeft: "4px" }}>%</span>
      </div>
    </div>
  )
}

export default GaugeChart
